export const getColorInfo = (color: string): { label: string; color: string } => {
  const colorMap: Record<string, { label: string; color: string }> = {
    white: { label: 'Branco', color: '#f8f9fa' },
    black: { label: 'Preto', color: '#212529' },
    silver: { label: 'Prata', color: '#adb5bd' },
    blue: { label: 'Azul', color: '#0d6efd' },
    red: { label: 'Vermelho', color: '#dc3545' },
    green: { label: 'Verde', color: '#198754' },
    yellow: { label: 'Amarelo', color: '#ffc107' },
    gray: { label: 'Cinza', color: '#6c757d' },
    brown: { label: 'Marrom', color: '#795548' },
    purple: { label: 'Roxo', color: '#6f42c1' },
    unknown: { label: 'Desconhecido', color: '#6c757d' },
  }

  return colorMap[color?.toLowerCase()] ?? { label: color || 'Não identificado', color: '#6c757d' }
}